import Block01 from '../modules/blocks/block-01';
import Block02 from '../modules/blocks/block-02';
import Block03 from '../modules/blocks/block-03';
import Block04 from '../modules/blocks/block-04';
import Block05 from '../modules/blocks/block-05';
import Block06 from '../modules/blocks/block-06';
import Block07 from '../modules/blocks/block-07';

function entry () {
    window.__DOMReady.then(() => {
        new Block01('.block-01');
        new Block02('.block-02');
        new Block03('.block-03');
        new Block04('.block-04');
        new Block05('.block-05');
        new Block06('.block-06');
        new Block07('.block-07');
    });
}

window.addEventListener('DOMContentLoaded', entry);
